<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents exclude-auto page-open-auto" id="TableOfContents1">
<div class="title-block exclude-auto" id="title-block2">
<h1 id="h13">Contents</h1>
</div>
<div class="named-lists toc-lists exclude-auto" id="toc-lists1">
<div class="list-named list-toc exclude-auto" id="list-toc1">
<ol id="ol1">
<li class="toc-chapter" id="toc-chapter2"><span href="#/9781783780853_booktitlepage#BookTitlePage1" title="Link target outside of Sample">Title Page</span></li>
<li class="toc-chapter" id="toc-chapter1"><a href="#/9781783780853_chapter_01#Chapter1">I’m Jack</a></li>
<li class="toc-fm" id="toc-fm1"><span href="#/9781783780853_copyrightinserted#h15" title="Link target outside of Sample">Copyright</span></li>
</ol>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781783780853_tableofcontents.vue?3053580b